export default from './page-metadata';



// WEBPACK FOOTER //
// ./app/components/page-metadata/index.js